import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { config } from '../config';
import Footer from '../components/Footer';
import Navbar from '../components/NavBar';
import './Css/Membership.css';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';

import Bkash from './../assets/images/Bkash.png';
import Nagad from './../assets/images/Nagad.png';
import { initFacebookPixel, trackEvent } from '../pixel';
import { PixelContext } from './Context/PixelContext';

const apiUrl = config.apiUrl;

const Transaction = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        transaction_id: '',
        referred_by: '',
    });

    const [item, setItem] = useState({
        name: 'Loading...',
        description: 'Fetching details...',
        amount: '',
        original_amount: '',
    });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [paymentMethod, setPaymentMethod] = useState('bkash');

    const { itemType, itemId, referrer } = useParams();
    const navigate = useNavigate();
     const pixelInitialized = useRef(false);
     const { pixel } = useContext(PixelContext);
    const pixelId = pixel?.pixel_id || null;

    useEffect(() => {
      if (pixelId && !pixelInitialized.current) {
        initFacebookPixel(pixelId);
        pixelInitialized.current = true;
        
        
        trackEvent('InitiateCheckout', {
            content_name: item.name,
            content_ids: [itemId],
            content_type: itemType === 'course' ? 'Course' : 
                        itemType === 'service' ? 'Service' : 'Membership',
            value: item.amount,
            currency: 'BDT'
        });
      }
    }, [pixelId]);

    useEffect(() => {
        const fetchItem = async () => {
            try {
                let response;
                let itemData;

                if (itemType === 'course') {
                    response = await axios.get(`${apiUrl}/courses/${itemId}`);
                    itemData = response.data.course;
                    setItem({
                        name: itemData.course_name || 'Course Name Not Available',
                        description: itemData.description || 'No description available for this course.',
                        amount: itemData.discount_price || itemData.selling_price || 'Not Available',
                        original_amount: itemData.discount_price ? itemData.selling_price : null,
                    });
                } else if (itemType === 'service') {
                    response = await axios.get(`${apiUrl}/services/${itemId}`);
                    itemData = response.data.service;
                    setItem({
                        name: itemData.service_name || 'Service Name Not Available',
                        description: itemData.description || 'No description available for this service.',
                        amount: itemData.discount_price || itemData.selling_price || 'Not Available',
                        original_amount: itemData.discount_price ? itemData.selling_price : null,
                    });
                } else if (itemType === 'membership') {
                    response = await axios.get(`${apiUrl}/memberships/${itemId}`);
                    itemData = response.data;

                    console.log(item)

                    setItem({
                        name: itemData.membership_type || 'Membership Type Not Available',
                        benefits:itemData.benefits || '',
                        description: itemData.membership_description || 'No description available for this membership.',
                        amount: itemData.discount_price || itemData.selling_price || 'Not Available',
                        original_amount: itemData.discount_price ? itemData.selling_price : null,
                    });
                }

                setFormData((prev) => ({
                    ...prev,
                    amount: itemData.discount_price || itemData.selling_price || '',
                }));
            } catch (error) {
                setItem({
                    name: 'Item Not Found',
                    description: 'Failed to fetch item details.',
                    amount: '',
                    original_amount: null,
                });
                console.error('Failed to fetch item details:', error);
            } finally {
                setLoading(false);
            }
        };

        if (itemId && itemType) fetchItem();
        if (referrer) setFormData((prev) => ({ ...prev, referred_by: referrer }));
    }, [itemId, referrer, itemType]);

       // Helper function to get cookies
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

      const getIconComponent = (iconName) => {
        const libraries = { ...FaIcons, ...MdIcons, ...AiIcons, ...BsIcons };
        const Icon = libraries[iconName];
        return Icon ? <Icon /> : <span>✅</span>;
      };
      

    const handleSubmit = async (e) => {
        e.preventDefault();

        const transactionData = {
            item_id: itemId,
            item_type: itemType,
            ...formData,
            referred_by: formData.referred_by || null,
        };

        try{
            const eventId = 'evt_' + crypto.randomUUID(); 
  
            // Get user data from form
            const name = formData.name;
            const phone = formData.mobile;
            const transactionId = formData.transaction_id;
            
            const eventData = {
                email: '', // Add email if available
                phone: phone,
                name: name,
                event: 'Purchase',
                content_type: itemType === 'course' ? 'Course' : 
                            itemType === 'service' ? 'Service' : 'Membership',
                content_name: item.name,
                content_ids: [itemId],
                event_source_url: window.location.href,
                fbc: getCookie('_fbc'),
                fbp: getCookie('_fbp'),
                event_id: eventId,
                external_id: phone,
                value: item.amount,
                currency: 'BDT',
            };


            trackEvent('Purchase', eventData);

            // Track server-side
            await axios.post(`${apiUrl}/fb-track`, {
                event: 'Purchase',
                ...eventData
            });
            } catch (error) {
            console.error('Facebook tracking failed:', error);
            }

        try {
            const response = await axios.post(`${apiUrl}/transactions`, transactionData);

            setMessage(response.data.message);
            setError('');
            navigate('/thanks');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to process the transaction. Please try again.');
            setMessage('');
        }
    };


    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-4 sm:px-6 lg:px-8 pt-32">
                <div className="max-w-6xl mx-auto">
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                        <div className="md:flex">
                            {/* Left Side: Product Details */}
                            <div className="md:w-1/2 bg-gradient-to-br from-indigo-600 to-blue-600 p-8 md:p-12 text-white">
                                <div className="mb-8">
                                    <span className="inline-block px-3 py-1 text-xs font-semibold bg-white text-indigo-600 rounded-full mb-4">
                                        {itemType === 'course' ? 'কোর্স' : 
                                         itemType === 'service' ? 'সেবা' : 
                                         'মেম্বারশিপ'}
                                    </span>
                                    <h1 className="text-3xl md:text-4xl font-bold mb-4">{item.name}</h1>
                                    
                                    <div className="flex items-center mb-6">
                                        <div className="mr-4">
                                            {item.original_amount ? (
                                                <>
                                                    <span className="text-4xl font-bold">৳{item.amount}</span>
                                                    <span className="ml-2 text-xl line-through text-indigo-200">৳{item.original_amount}</span>
                                                </>
                                            ) : (
                                                <span className="text-4xl font-bold">৳{item.amount}</span>
                                            )}
                                        </div>
                                        {item.original_amount && (
                                            <span className="bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-sm font-bold">
                                                {Math.round(((item.original_amount - item.amount) / item.original_amount) * 100)}% OFF
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="mb-8">
                                     {/* Dynamic Benefits */}
                                    {item.benefits && item.benefits.length > 0 && (
                                    <div className="mt-6 mb-4">
                                        {item.benefits.map((benefit, i) => (
                                        <div key={i} className="flex items-center mb-2  font-bold">
                                            <span className="mr-2">{getIconComponent(benefit.icon)}</span>
                                            <span className="text-gray-50">{benefit.benefit_name}</span>
                                        </div>
                                        ))}
                                    </div>
                                    )}

                                </div>

                                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                                    <h3 className="text-xl font-semibold mb-4">পেমেন্ট করার নিয়ম</h3>
                                    
                                    <div className="flex space-x-4 mb-6">
                                        <button 
                                            onClick={() => setPaymentMethod('bkash')}
                                            className={`px-4 py-2 rounded-lg font-medium ${paymentMethod === 'bkash' ? 'bg-white text-indigo-600' : 'bg-indigo-700 text-white'}`}
                                        >
                                            বিকাশ
                                        </button>
                                        <button 
                                            onClick={() => setPaymentMethod('nagad')}
                                            className={`px-4 py-2 rounded-lg font-medium ${paymentMethod === 'nagad' ? 'bg-white text-indigo-600' : 'bg-indigo-700 text-white'}`}
                                        >
                                            নগদ
                                        </button>
                                    </div>

                                    {paymentMethod === 'bkash' ? (
                                        <div>
                                            <div className="flex items-center mb-3">
                                                <img src={Bkash} alt="bKash" className="h-8 mr-3" />
                                                <div>
                                                    <p className="font-medium">বিকাশ পার্সোনাল</p>
                                                    <p className="text-xl font-bold">+8801635494643</p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="flex items-center mb-3">
                                                <img src={Nagad} alt="Nagad" className="h-8 mr-3" />
                                                <div>
                                                    <p className="font-medium">নগদ পার্সোনাল</p>
                                                    <p className="text-xl font-bold">+8801635494643</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="mt-6 text-sm text-indigo-100">
                                        <p>১. উপরের নাম্বারে টাকা পাঠান</p>
                                        <p>২. ট্রানজেকশন আইডি নিচের ফর্মে লিখুন</p>
                                        <p>৩. সাবমিট বাটনে ক্লিক করুন</p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side: Payment Form */}
                            <div className="md:w-1/2 p-8 md:p-12">
                                <div className="max-w-md mx-auto">
                                    <h2 className="text-2xl font-bold text-gray-800 mb-1">পেমেন্ট সম্পূর্ণ করুন</h2>
                                    <p className="text-gray-500 mb-8">আপনার তথ্য প্রদান করুন</p>
                                    
                                    <form onSubmit={handleSubmit} className="space-y-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">আপনার নাম</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                required
                                                placeholder="পূর্ণ নাম লিখুন"
                                            />
                                        </div>

                                        <div>
                                            <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-1">মোবাইল নম্বর</label>
                                            <input
                                                type="text"
                                                name="mobile"
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                required
                                                placeholder="01XXXXXXXXX"
                                            />
                                        </div>

                                        <div>
                                            <label htmlFor="transaction_id" className="block text-sm font-medium text-gray-700 mb-1">ট্রানজেকশন আইডি</label>
                                            <input
                                                type="text"
                                                name="transaction_id"
                                                value={formData.transaction_id}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                required
                                                placeholder={`${paymentMethod === 'bkash' ? 'bKash' : 'Nagad'} ট্রানজেকশন আইডি`}
                                            />
                                        </div>

                                        <div className="hidden">
                                            <input
                                                type="text"
                                                name="referred_by"
                                                value={formData.referred_by}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="w-full py-3 px-6 bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white font-semibold rounded-lg shadow-md transition duration-300"
                                        >
                                            পেমেন্ট সাবমিট করুন
                                        </button>
                                    </form>

                                    {error && (
                                        <div className="mt-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700">
                                            <p>{error}</p>
                                        </div>
                                    )}

                                    <div className="mt-8 border-t pt-6">
                                        <h3 className="text-sm font-medium text-gray-500 mb-3">নিরাপদ পেমেন্ট</h3>
                                        <div className="flex space-x-4">
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png" alt="Secure Payment" className="h-8 opacity-70" />
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-8 opacity-70" />
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Mastercard_2019_logo.svg/1200px-Mastercard_2019_logo.svg.png" alt="Mastercard" className="h-8 opacity-70" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Transaction;